import './Legal.css';

export default function Accessibility() {
    return (
        <div className="legal-page">
            <div className="legal-container">
                <h1>Accessibility Statement</h1>
                <p className="last-updated">Last updated: December 2024</p>

                <section>
                    <h2>Our Commitment</h2>
                    <p>autopsyURL is committed to ensuring digital accessibility for people with diverse abilities. We are continually improving the user experience for everyone and applying relevant accessibility standards.</p>
                </section>

                <section>
                    <h2>Conformance Status</h2>
                    <p>We aim to conform to the Web Content Accessibility Guidelines (WCAG) 2.1 Level AA. These guidelines explain how to make web content more accessible for people with disabilities.</p>
                </section>

                <section>
                    <h2>Accessibility Features</h2>
                    <p>Our website includes the following accessibility features:</p>
                    <ul>
                        <li><strong>Keyboard navigation</strong> - All interactive elements are accessible via keyboard</li>
                        <li><strong>Skip navigation</strong> - Skip to main content link for keyboard users</li>
                        <li><strong>Focus indicators</strong> - Visible focus states on all interactive elements</li>
                        <li><strong>Semantic HTML</strong> - Proper heading structure and landmarks</li>
                        <li><strong>Alt text</strong> - Descriptive text for images</li>
                        <li><strong>Color contrast</strong> - Text meets WCAG contrast requirements</li>
                        <li><strong>Responsive design</strong> - Works on various devices and screen sizes</li>
                    </ul>
                </section>

                <section>
                    <h2>Assistive Technologies</h2>
                    <p>autopsyURL is designed to be compatible with:</p>
                    <ul>
                        <li>Screen readers (NVDA, JAWS, VoiceOver)</li>
                        <li>Screen magnification software</li>
                        <li>Speech recognition software</li>
                        <li>Keyboard-only navigation</li>
                    </ul>
                </section>

                <section>
                    <h2>Known Limitations</h2>
                    <p>We are working to address the following known accessibility issues:</p>
                    <ul>
                        <li>Some third-party content may not be fully accessible</li>
                        <li>Complex data visualizations may need alternative text descriptions</li>
                    </ul>
                </section>

                <section>
                    <h2>Feedback</h2>
                    <p>We welcome your feedback on the accessibility of autopsyURL. Please let us know if you encounter accessibility barriers:</p>
                    <ul>
                        <li>Email: accessibility@autopsyurl.com</li>
                    </ul>
                    <p>We try to respond to accessibility feedback within 5 business days.</p>
                </section>
            </div>
        </div>
    );
}
